import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TheRealReasonsStudentsFallBehind from "./sections/TheRealReasonsStudentsFallBehind";
import AboutPreview from "./sections/AboutPreview";
import OurServicesOverview from "./sections/OurServicesOverview";
import Benefit from "./sections/Benefit";
import Testimonials from "./sections/Testimonials";
import GetStartedCta from "./sections/GetStartedCta";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <TheRealReasonsStudentsFallBehind />
      <AboutPreview />
      <OurServicesOverview />
      <Benefit />
      <Testimonials />
      <GetStartedCta />
      <Footer />
    </div>;
}